import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import TickIcon from "./icon-tick.svg";
export const Container = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1yc3qie1"
} : {
  target: "e1yc3qie1",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "zjik7",
  styles: "display:flex"
} : {
  name: "zjik7",
  styles: "display:flex",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSW1DIiwiZmlsZSI6InN0eWxlcy50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIjtcblxuaW1wb3J0IFRpY2tJY29uIGZyb20gXCIuL2ljb24tdGljay5zdmdcIjtcblxuZXhwb3J0IGNvbnN0IENvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG5gO1xuXG5leHBvcnQgY29uc3QgU3R5bGVkVGlja0ljb24gPSBzdHlsZWQoVGlja0ljb24pYFxuICBmbGV4OiBub25lO1xuXG4gIGlubGluZS1zaXplOiAyOHB4O1xuICBibG9jay1zaXplOiAyOHB4O1xuICBtYXJnaW4taW5saW5lLWVuZDogMTZweDtcbmA7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
export const StyledTickIcon = /*#__PURE__*/_styled(TickIcon, process.env.NODE_ENV === "production" ? {
  target: "e1yc3qie0"
} : {
  target: "e1yc3qie0",
  label: "StyledTickIcon"
})(process.env.NODE_ENV === "production" ? {
  name: "dyx8jd",
  styles: "flex:none;inline-size:28px;block-size:28px;margin-inline-end:16px"
} : {
  name: "dyx8jd",
  styles: "flex:none;inline-size:28px;block-size:28px;margin-inline-end:16px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBUThDIiwiZmlsZSI6InN0eWxlcy50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIjtcblxuaW1wb3J0IFRpY2tJY29uIGZyb20gXCIuL2ljb24tdGljay5zdmdcIjtcblxuZXhwb3J0IGNvbnN0IENvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG5gO1xuXG5leHBvcnQgY29uc3QgU3R5bGVkVGlja0ljb24gPSBzdHlsZWQoVGlja0ljb24pYFxuICBmbGV4OiBub25lO1xuXG4gIGlubGluZS1zaXplOiAyOHB4O1xuICBibG9jay1zaXplOiAyOHB4O1xuICBtYXJnaW4taW5saW5lLWVuZDogMTZweDtcbmA7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});